// extracted by mini-css-extract-plugin
module.exports = {"badge":"OfferBadge_badge__PK4OK","period":"OfferBadge_period__L3upc","savings":"OfferBadge_savings__xi21_"};